module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAOCAYAAADABlfOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEQSURBVHgBzZLNzYJAEIZ3Yc+EEijh+4ADN9cSrEBKwAq0A2MF2oF2YLyR8CMduCV4hgR8R1nDwR+MmvgmZJmX4ZmdzHAGua47xxFyzm32RE3TKNM0R0mSFPdyBIAEi5C8Q6yeMG3kDuq6XuL9X5t/kGEYxBngmQh4Dn1A9ehRdS3P87Y4ZAuT+G+q47aTyNBBVVVH9qJwuxUBqUvccNhCbcHeEEGFEKs4jhW7dHH234KmaTq7WYx9Qb8HxfTtj0MxqAJ7vgTc+RgUUlilELt6wOTX2qTpH9uqEhVVD9C15TzPpe/7tKchwjF5KHLgQRA4WPx9N7mHFlmWRV2DOGVZSsuyNrxjhH1ouEkB4OZRzglk4lnfjq9iTwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/button/krxVideo.png
// module id = iVim
// module chunks = 1